// importer la librairie de react
import React, { useEffect, useState } from "react"
import { Box } from "@mui/material"
import { PageConfig, CwComponentConfig } from "../../models/pageConfig"
import CwImage from "./cw-image"
import CwText from "./cw-text"
import ComponentsUtils from "../../utils/components"
import ActionService from "../../services/action"
import DialogService from "../../services/dialog"
import { DialogType } from "../../models/dialog"
import UIService from "../../services/UIService"

const CwHeader = (
    props: PageConfig<CwComponentConfig.Header>
): React.JSX.Element | null => {
    const { config } = props
    // création de toute les variables à partir des config
    const {
        title,
        titleVariant,
        titleIcon,
        titleColor,
        subTitle,
        subTitleVariant,
        subTitleIcon,
        subTitleColor,
        pipe,
        rightItem,
        leftItem,
        leftIcon,
        textClassName,
        textWrapperClassName,
        useRefreshListener,
        divider,
        dividerClass,
        fontWeight,
        leftClass,
        rightClass,
    } = config

    const className = config.className ? config.className : ""
    const background = config.background
        ? UIService.getLinearGradByName(config.background)
        : "transparent"

    const [state, setState] = useState({
        show: true,
        text: title || "",
        variant: titleVariant,
        textIcon: titleIcon,
        color: titleColor,
        subTitle,
        subTitleVariant,
        subTitleIcon,
        subTitleColor,
        pipe,
        className: textWrapperClassName || "",
        textClassName: textClassName || "",
        rightItem,
        leftItem,
        useRefreshListener,
        divider,
        dividerClass,
        fontWeight,
        leftClass,
        rightClass,
    })
    const init = () => {
        // exec les action d'ini si présentes
        if (props.actions && props.actions.length)
            ActionService.exec(props.actions).then((conf) => {
                // override des attrs de state par ceux de conf
                if (conf?.type === "config")
                    // TODO only title handled
                    setState({ ...state, ...conf.value })
            })
        setState({
            show: true,
            text: title || "",
            variant: titleVariant,
            textIcon: titleIcon,
            color: titleColor,
            subTitle,
            subTitleVariant,
            subTitleIcon,
            subTitleColor,
            pipe,
            className: textWrapperClassName || "",
            textClassName: textClassName || "",
            rightItem,
            leftItem,
            useRefreshListener,
            divider,
            dividerClass,
            fontWeight,
            rightClass,
            leftClass,
        })
    }

    useEffect(() => {
        let subId: string | null = null
        // on s'abonne aux changements de route
        if (useRefreshListener)
            subId = DialogService.getInstance().subscribe(
                "pageRefesh",
                DialogType.REFRESH,
                props.name,
                () => {
                    init()
                }
            )

        init()
        // unsubscribe
        return () => {
            if (subId) DialogService.getInstance().unsubscribe(subId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setState({
            show: true,
            text: title || "",
            variant: titleVariant,
            textIcon: titleIcon,
            color: titleColor,
            subTitle,
            subTitleVariant,
            subTitleIcon,
            subTitleColor,
            pipe,
            className: textWrapperClassName || "",
            textClassName: textClassName || "",
            rightItem,
            leftItem,
            useRefreshListener,
            divider,
            dividerClass,
            fontWeight,
            rightClass,
            leftClass,
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config])
    const renderRightItem = () => {
        return ComponentsUtils.initChildFieldsComponent(state.rightItem)
    }
    const renderLeftItem = () => {
        return ComponentsUtils.initChildFieldsComponent(state.leftItem)
    }
    return state.show ? (
        <Box
            className={`flexBox spaceBetween ${className}`}
            style={{ background }}
        >
            {leftItem ? (
                <div className={`flexBoxWrap ${leftClass || ""}`}>
                    {renderLeftItem()}
                </div>
            ) : null}
            {leftIcon ? (
                <div>
                    <CwImage
                        name="leftIconHeader"
                        type="image"
                        config={leftIcon}
                    />
                </div>
            ) : null}
            {title ? (
                <CwText name="textHeader" type="text" config={state} />
            ) : null}
            {divider ? <div className={state.dividerClass}></div> : null}
            {rightItem ? (
                <div className={`flexBoxWrap ${rightClass || ""}`}>
                    {renderRightItem()}
                </div>
            ) : null}
        </Box>
    ) : null
}
export default CwHeader
